import React from "react";
import DataGridComponent from "Utils/Constants/DataGridComponent";
import { tamimaList } from "Utils/Helpers/TableColumns";

export default function TableTamimaData({ data }) {
  return <DataGridComponent data={data} columns={tamimaList} />;
}